import minigameService, { getMinigameErrorMessage } from '../../services/minigameService';

const state = {
  lastCompletion: null,
  loading: false,
  error: null,
  activeMinigame: null, // Stores the currently active minigame configuration (vinda do servidor)
};

const getters = {
  getLastCompletion: state => state.lastCompletion,
  isLoading: state => state.loading,
  getError: state => state.error,
  getActiveMinigame: state => state.activeMinigame,
};

const mutations = {
  SET_LAST_COMPLETION(state, completion) {
    state.lastCompletion = completion;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_ACTIVE_MINIGAME(state, config) {
    state.activeMinigame = config;
  },
  CLEAR_ACTIVE_MINIGAME(state) {
    state.activeMinigame = null;
  }
};

const actions = {
  // Inicia um minigame: o servidor valida os trabalhos diários, registra a sessão
  // e devolve a configuração oficial (pagamento/meta vêm do servidor)
  async startMinigame({ commit }, { type, difficulty, difficultyName } = {}) {
    if (!type || !difficulty) {
      throw new Error('Invalid minigame configuration');
    }

    commit('SET_ERROR', null);

    try {
      const response = await minigameService.startMinigame(type, difficulty);
      const config = response.data || {};

      commit('SET_ACTIVE_MINIGAME', {
        type,
        difficulty: config.difficulty || difficulty,
        payment: parseInt(config.payment) || 0,
        targetScore: parseInt(config.targetScore) || 0,
        worksToDecrease: parseInt(config.worksToDecrease) || 1,
        // Nome traduzido do cliente só para exibição
        difficultyName: difficultyName || config.difficultyName || '',
        timestamp: Date.now()
      });

      return type; // Return the type for routing purposes
    } catch (error) {
      const message = getMinigameErrorMessage(error, 'Não foi possível iniciar o trabalho.');
      commit('SET_ERROR', message);
      throw new Error(message);
    }
  },

  // Complete a minigame
  async completeMinigame({ commit, state, rootState }, { success = true } = {}) {
    // Check if there's an active minigame configuration
    if (!state.activeMinigame) {
      throw new Error('No active minigame found');
    }

    // Only proceed if the player won the game
    if (!success) {
      commit('CLEAR_ACTIVE_MINIGAME');
      return { success: false };
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      // Pagamento e trabalhos são calculados no servidor a partir da sessão ativa
      const response = await minigameService.completeMinigame();
      const result = response.data || {};
      const updatedPlayer = result.player || {};

      commit('SET_LAST_COMPLETION', result);

      // Atualiza só os campos alterados, preservando as relações já carregadas
      const currentPlayer = rootState.player && rootState.player.playerData;
      if (currentPlayer) {
        commit('player/SET_PLAYER_DATA', {
          ...currentPlayer,
          coins: updatedPlayer.coins,
          worksDaily: updatedPlayer.worksDaily
        }, { root: true });
      }

      // Clear the active minigame
      commit('CLEAR_ACTIVE_MINIGAME');

      return { success: true, data: result, payment: result.payment };
    } catch (error) {
      const message = getMinigameErrorMessage(error, 'Erro ao completar o minigame');
      commit('SET_ERROR', message);
      throw new Error(message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Cancel an active minigame (when player exits without completing)
  cancelMinigame({ commit }) {
    commit('CLEAR_ACTIVE_MINIGAME');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
